// Copied from Acend
import { Box, Icon, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { ImCheckmark } from "react-icons/im";

/** Object with display text as key and const as value to create options from */
export type Options = Record<string, string>;

enum SelectBackground {
  gray = "#f5f5f5",
  transparent = "transparent",
}

type OptionProps<T extends Options> = {
  label: string;
  itemValue: T[keyof T];
  handleClick: (itemValue: T[keyof T]) => void;
  highlightedIndex: number;
  index: number;
  testId: string;
  isDisabled?: boolean;
  isSelected?: boolean;
};

const Option = <T extends Options>({
  label,
  itemValue,
  handleClick,
  highlightedIndex,
  index,
  testId,
  isSelected,
  isDisabled,
}: OptionProps<T>) => {
  const [backgroundColor, setBackgroundColor] = useState(
    SelectBackground.transparent
  );

  useEffect(() => {
    return highlightedIndex === index
      ? setBackgroundColor(SelectBackground.gray)
      : setBackgroundColor(SelectBackground.transparent);
  }, [highlightedIndex, index]);

  return (
    <Box
      height={label ? "auto" : "35px"}
      key={itemValue}
      onClick={() => handleClick(itemValue)}
      onFocus={() => {
        setBackgroundColor(SelectBackground.gray);
      }}
      onBlur={() => {
        setBackgroundColor(SelectBackground.transparent);
      }}
      onMouseOver={() => {
        isDisabled
          ? setBackgroundColor(SelectBackground.transparent)
          : setBackgroundColor(SelectBackground.gray);
      }}
      onMouseOut={() => {
        setBackgroundColor(SelectBackground.transparent);
      }}
      cursor="pointer"
      padding="0.5rem"
      display="flex"
      alignItems="center"
      backgroundColor={backgroundColor}
      color={isDisabled ? "gray" : "black"}
      id={`option-${index}`}
      aria-selected={isSelected}
      data-testid={`${testId}-select-option-${itemValue}`}
      aria-hidden
      aria-disabled={isDisabled}
      role="option"
      data-value={itemValue}
      pointerEvents={isDisabled ? "none" : "auto"}
    >
      {isSelected && (
        <Icon as={ImCheckmark} boxSize=".8rem" mx=".3rem" color="blue.400" />
      )}
      <Text pl={isSelected ? "0rem" : "1.4rem"} overflowWrap="anywhere">
        {label}
      </Text>
    </Box>
  );
};

export default Option;
